


































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { debounce } from 'lodash';
import { getRoomList, getUserByRoomID } from '@/api/parking-space-list';
import { mobile, idNumber } from '@root/utils/validators';
import { carDelete } from '@/api/special-authorized-car-management';
import RoomNumber from './room-number.vue';

const debounceGetRooms = debounce(function(params, callback) {
  getRoomList(params)
    .then(callback)
    .catch(callback);
}, 600);

@Component({
  components: {
    RoomNumber
  }
})
export default class UserInfo extends Vue {
  /**
   * parkId
   */
  @Prop({ type: String }) parkId!: string;

  @Prop({ type: Number, default: 8 }) spanValue: number;

  @Prop({ type: Object }) form: {};

  @Prop({ type: String }) transfer: string;

  private ownerId = null;

  private validatorsPhone = mobile('请输入正确的手机号');
  private validatorsIdNumber = idNumber('请输入正确的身份证号', false);
  roomList: any = {
    loading: null,
    data: []
  };
  loadingUserId = false;
  roomNum = [];
  data() {
    return {};
  }

  /**
   *
   */
  handleChange(name, e) {
    const value = e.target.value;

    this.$emit('change', { [name]: String(value) });
  }
  /**
   * 房间号
   */
  // async handleRoomChange(array: string[], nodeArry) {
  //   try {
  //     array = array.filter(it => !!it);

  //     const isAdd = this.roomNum.length < array.length;

  //     if (!isAdd) {
  //       const params: any = { roomNum: array.join(',') };
  //       if (array.length === 0) {
  //         params.userName = '';
  //       }
  //       this.roomNum = array;
  //       this.$emit('change', params);
  //       return;
  //     }

  //     this.loadingUserId = true;

  //     const lastRoomObj = nodeArry[nodeArry.length - 1];
  //     const { status, data = {}, msg } = await getUserByRoomID(lastRoomObj.data.attrs['data-id']);
  //     const { mobile: phoneNum, ownerId, ownerName: userName } = data;

  //     if (status !== '9999') throw new Error(msg || '服务响应失败，请重新选择');

  //     if (!userName) {
  //       throw new Error('没有获取到用户信息，请重新选择');
  //     }

  //     if (this.ownerId && this.ownerId !== ownerId) {
  //       throw new Error('无法选中房号，所属用户与前一个选择不同，请重新选择');
  //     }

  //     // 记录选择的房号绑定的用户
  //     this.ownerId = ownerId;
  //     this.roomNum = array;

  //     this.$emit('change', { roomNum: array.join(','), phoneNum, userName });
  //   } catch (err) {
  //     this.$message.warning(err.message);
  //   } finally {
  //     if (this.loadingUserId) this.loadingUserId = false;
  //     // 清除选择的房号绑定的用户
  //     if (array.length === 0) this.ownerId = null;
  //   }
  // }

  /**
   * 姓名模糊查询
   */
  // async fetchRoomNum(searchParam) {
  //   if (!searchParam) return;

  //   this.roomList = {
  //     loading: true,
  //     data: []
  //   };

  //   debounceGetRooms({ parkId: this.parkId, searchParam }, req => {
  //     const { status, data = [], msg } = req;

  //     if (status === '9999') {
  //       // if (data.some(it => it.name === roomNum)) {
  //       //   this.$emit('change', { roomNum: it., phoneNum: '1666666666667' })
  //       // }
  //     } else {
  //       this.$message.error(msg || '获取房间列表失败');
  //     }
  //     this.roomList = {
  //       loading: false,
  //       data
  //     };
  //   });
  // }

  private showRoom: boolean = false;
  /**
   * 查询房间号
   */
  toRoom() {
    this.showRoom = true;
  }
}
